import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import { C as Collection } from './collection-BRs6fNly.js';
import './fetchHTML-CGNR3V1z.js';
import './parseHTML-Om2c1Ayj.js';
import './uniq-D7II7obF.js';

/**
 * Get the section id from an id
 * @param {string} id - The id to get the section id from
 * @returns {string} - The section id
 */
function getSectionId({ id = '' }) {
  return id.includes('__') ? id.split('__').pop() : id.replace('shopify-section-', '');
}

class ListingGrid extends HTMLElement {
  #unsubscriber;
  #closestSection = this.closest('[id^="shopify-section-"]');
  #sectionId = getSectionId(this.#closestSection);

  connectedCallback() {
    Collection.sections.push(this.#sectionId);

    // Subscribe to filters updated event
    this.#unsubscriber = PubSub.subscribe('collection:filter', ({ status, data }) => {
      status === 'success' && this.#replaceListingGrid(data.sections);
    });
  }

  disconnectedCallback() {
    this.#unsubscriber();
  }

  /**
   * Replace listing grid
   * @param {object[]} sections - Sections to replace
   * @param {string} sections.section - Section to replace
   * @param {Document} sections.html - Html to replace the current listing grid
   */
  #replaceListingGrid(sections) {
    const section = sections.find(({ section }) => section === this.#sectionId);
    if (!section) return;

    const parsedListingGrid = section.html.querySelector('listing-grid');

    // Clone the element to avoid modifying the shared HTML object
    const clonedListingGrid = parsedListingGrid.cloneNode(true);

    this.innerHTML = clonedListingGrid.innerHTML;
  }
}

customElements.define('listing-grid', ListingGrid);
